import styled from 'styled-components';

import { Spinner } from '@creditornot/cb-progress';
import { ModalContent } from '@creditornot/cbt-modal';

const Root = styled(ModalContent)`
  display: flex;
  justify-content: center;
`;

export const ModalSpinner: React.FC = () => {
  return (
    <Root>
      <Spinner size="large" />
    </Root>
  );
};
